/**
 * Route for `igaming-wager-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingWagerTrackingPage } from "../features/igaming-wager-tracking/IgamingWagerTrackingPage";

export const igamingWagerTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-wager-tracking",
	component: IgamingWagerTrackingPage,
});

export default igamingWagerTrackingRoute;
